/* ============================================================================
 * Project        : Deloitte Digital Compliance
 * File           : NewRequestTab.jsx
 * Version        : 1.0.0
 * Author         : Team Neubinary
 * Created On     : 2026-06-24
 *
 * Description    : Digital Compliance for Automation and Governance
 *
 * Change History :
 * ----------------------------------------------------------------------------
 * Date         | Version | Author           | Description
 * ----------------------------------------------------------------------------
 * 2026-06-24   | 1.0.0   | Team Neubinary   | Initial creation
 * <YYYY-MM-DD> | x.x.x   | <Name/Team>      | <Change description>
 * ============================================================================
 *
 * Copyright (c) 2026 AU79 Consulting Services Pvt. Ltd.
 * All Rights Reserved.
 *
 * This source code and its contents are confidential and proprietary to
 * AU79 Consulting Services Pvt. Ltd. Unauthorized copying, reproduction,
 * modification, distribution, or disclosure of this material, in whole or
 * in part, is strictly prohibited without prior written permission from
 * AU79 Consulting Services Pvt. Ltd.
 * ============================================================================
 */
/**
 * @author : Narender - narender@au79consulting.com
 * @Date : 23-09-2024
 * @description : To request co-owner/editor/viewer access to the project/zones/ee component/software module
 */
import { useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import {
  HandleApiActions,
  labCar,
  userManagementApis,
} from "../../../redux/actions";
import customConsole from "../../../config/customConsole";
import {
  Box,
} from "@mui/material";
import {

  EEDetails,
  ModuleAccessTypes,
  ProjectDetails,
  SelectModules,
  SWMDetails,
  VariantDetailsBox,
  VehicleComponentDetails,
  VehicleSystemDetails,
} from "../../../components";
import CustomButtonV2 from "../../../components/customComponentsV2/common/button/CustomButtonV2";
import CustomRadioButtonV3 from "../../../components/customComponentsV2/common/radioButton/CustomRadioButtonV3";
import CustomFormTextFieldV2 from "../../../components/customComponentsV2/common/textField/CustomFormTextFieldV2";

function NewRequestTab({
  selectedProjectDetails,
  projectStatus,
  moduleTypes,
  accessTypes,
}) {
  console.log(
    "selectedProjectDetailsselectedProjectDetailsselectedProjectDetails",
    selectedProjectDetails,
  );
  const dispatch = useDispatch();

  // New Requests Buttons
  const [selectedPaBtn, setSelectedPaBtn] = useState(moduleTypes?.VARIANT);

  // Co-owners state
  // const [coOwnersOptionsList, setCoOwnersOptionsList] = useState([]);
  // const [selectedCoOwner, setSelectedCoOwner] = useState(null);

  // Access type
  const [selectedAtBtn, setSelectedAtBtn] = useState(accessTypes?.COOWNER);

  // Variant States
  const [variantDetails, setVariantDetails] = useState([]);
  const [variantOptionsList, setVariantOptionsList] = useState([]);
  const [selectedVariant, setSelectedVariant] = useState(null);
  const [selectedVariantDetails, setSelectedVariantDetails] = useState(null);

  // Zones States
  const [zoneOptionsList, setZoneOptionsList] = useState([]);
  const [selectedZone, setSelectedZone] = useState(null);
  const [selectedZoneDetails, setSelectedZoneDetails] = useState(null);

  // EE Components States
  const [zoneEEDetails, setZoneEEDetails] = useState([]);
  const [eeOptionsList, setEEOptionsList] = useState([]);
  const [selectedEE, setSelectedEE] = useState(null);
  const [selectedEEDetails, setSelectedEEDetails] = useState(null);

  // Software Modules States
  const [eeSwmDetails, setEESwmDetails] = useState([]);
  const [swmOptionsList, setSWMOptionsList] = useState([]);
  const [selectedSWM, setSelectedSWM] = useState(null);
  const [selectedSWMDetails, setSelectedSWMDetails] = useState(null);

  // Vehicle Systems States
  const [vehicleSystemDetails, setVehicleSystemDetails] = useState([]);
  const [vehicleSystemOptionsList, setVehicleSystemOptionsList] = useState([]);
  const [selectedVehicleSystem, setSelectedVehicleSystem] = useState(null);
  const [selectedVehicleSystemDetails, setSelectedVehicleSystemDetails] =
    useState(null);

  // Vehicle Components States
  const [vehicleComponentDetails, setVehicleComponentDetails] = useState([]);
  const [vehicleComponentOptionsList, setVehicleComponentOptionsList] =
    useState([]);
  const [selectedVehicleComponent, setSelectedVehicleComponent] =
    useState(null);
  const [selectedVehicleComponentDetails, setSelectedVehicleComponentDetails] =
    useState(null);

  // Reason for access text field state
  const [reasonForAccess, setReasonForAccess] = useState("");
  const [accessTypeKey, setAccessTypeKey] = useState(0);

  useEffect(() => {
    setAccessTypeKey((k) => k + 1);
  }, [selectedPaBtn]);

  console.log(selectedPaBtn, "selectedPaBtnselectedPaBtn");
  // Functions to handle data //
  // Get Variant Details
  const getVariantDetails = async ({ projectId }) => {
    let apiDetails = labCar.get_variant_details;

    customConsole({
      ...apiDetails,
      params: {
        project_id: projectId,
        is_complete_details_required: false,
        is_for_access: true,
      },
    });

    const resp = await dispatch(
      HandleApiActions({
        ...apiDetails,
        params: {
          project_id: projectId,
          is_complete_details_required: true,
          is_for_access: true,
        },
      }),
    );

    if (resp.error) {
      setVariantDetails([]);
    } else {
      setVariantDetails(resp.data);
    }
  };

  // Get EE Components Details
  const getZoneEEDetails = async ({ projectId, variantId, zonePosition }) => {
    let apiDetails = labCar.get_ee_components_pa;

    customConsole({
      ...apiDetails,
      params: {
        project_id: projectId,
        variant_id: variantId,
        ...(zonePosition && { zone_position: zonePosition }),
        // is_for_req_access: true,
      },
    });

    const resp = await dispatch(
      HandleApiActions({
        ...apiDetails,
        params: {
          project_id: projectId,
          variant_id: variantId,
          status: true,
          ...(zonePosition && { zone_position: zonePosition }),
          // is_for_req_access: true,
        },
      }),
    );

    if (resp.error) {
      setZoneEEDetails([]);
    } else {
      setZoneEEDetails(resp.data);
    }
  };

  // Get Software Module Details
  const getEESwmDetails = async ({ projectId, variantId, eeId }) => {
    let apiDetails = labCar.get_sw_modules_pa;

    customConsole({
      ...apiDetails,
      params: {
        project_id: projectId,
        variant_id: variantId,
        ee_id: eeId,
        // is_for_req_access: true,
      },
    });

    const resp = await dispatch(
      HandleApiActions({
        ...apiDetails,
        params: {
          project_id: projectId,
          variant_id: variantId,
          ee_id: eeId,
          // is_for_req_access: true,
          status: true,
        },
      }),
    );

    if (resp.error) {
      setEESwmDetails([]);
    } else {
      setEESwmDetails(resp.data);
    }
  };

  /**
   * @author : Narender
   * @Date : 03-03-2025
   * @description : Fetches vehicle systems Details
   * @param {project_id, variant_id, zone_position}
   * @return {msg: "", data: [], error: true | false}
   */
  const getVehicleSystemsDetails = async ({
    projectId,
    variantId,
    zonePosition,
  }) => {
    const apiDetails = labCar.get_vehicle_systems_all;
    const resp = await dispatch(
      HandleApiActions({
        ...apiDetails,
        show_toast: false,
        params: {
          project_id: Number(projectId),
          variant_id: Number(variantId),
          ...(zonePosition && { zone_position: zonePosition }), // Add zone position if zonal
          // is_for_req_access: true,
        },
      }),
    );
    if (resp.error) {
      setVehicleSystemDetails([]);
    } else {
      setVehicleSystemDetails(resp.data);
    }
  };
  /**
   * @author : Narender
   * @Date : 03-03-2025
   * @description : Fetches vehicle components Details
   * @param {project_id, variant_id, vs_id}
   * @return {msg: "", data: [], error: true | false}
   */
  const getVehicleComponentsDetails = async ({
    projectId,
    variantId,
    vsId,
  }) => {
    const apiDetails = labCar.get_vehicle_components_all;
    const resp = await dispatch(
      HandleApiActions({
        ...apiDetails,
        show_toast: false,
        params: {
          project_id: projectId,
          variant_id: variantId,
          vs_id: vsId,
          // is_for_req_access: true,
        },
      }),
    );
    if (resp.error) {
      setVehicleComponentDetails([]);
    } else {
      setVehicleComponentDetails(resp.data);
    }
  };

  // Request access
  const requestAccess = async ({
    accessType,
    moduleType,
    projectId,
    variantId,
    eeId,
    swmId,
    vsId,
    vcId,
    zonePosition,
    requestReason,
  }) => {
    let apiDetails = userManagementApis.request_access;

    const resp = await dispatch(
      HandleApiActions({
        ...apiDetails,
        params: {
          access_type: accessType,
          module_type: moduleType,
          project_id: Number(projectId),
          variant_id: Number(variantId),
          ...(eeId && { ee_id: Number(eeId) }),
          ...(swmId && { swm_id: Number(swmId) }),
          ...(zonePosition && { zone_position: zonePosition }),
          ...(vsId && { vs_id: Number(vsId) }),
          ...(vcId && { vc_id: Number(vcId) }),
          request_reason: requestReason,
        },
        show_toast: true,
      }),
    );
  };


  /* UseEffects */
  useEffect(() => {
    // Make the states to default when the project is changed
    // access type buttons
    setSelectedPaBtn(moduleTypes?.VARIANT);
    // Variant
    setVariantOptionsList([]);
    setSelectedVariant(null);
    setSelectedVariantDetails(null);
    // Zones
    setZoneOptionsList([]);
    setSelectedZone(null);
    setSelectedZoneDetails(null);
    // EE Components
    setEEOptionsList([]);
    setSelectedEE(null);
    setSelectedEEDetails(null);
    // Software Modules
    setSWMOptionsList([]);
    setSelectedSWM(null);
    setSelectedSWMDetails(null);
    // Vehicle Systems
    setVehicleSystemOptionsList([]);
    setSelectedVehicleSystem(null);
    setSelectedVehicleSystemDetails(null);
    // Vehicle Components
    setVehicleComponentOptionsList([]);
    setSelectedVehicleComponent(null);
    setSelectedVehicleComponentDetails(null);
  }, [selectedProjectDetails]);

  useEffect(() => {
    // Make the reason for access to default, when the data is changed
    setReasonForAccess("");
  }, [
    selectedProjectDetails,
    selectedPaBtn,
    selectedAtBtn,
    selectedVariant,
    selectedZone,
    selectedEE,
    selectedSWM,
    selectedVehicleSystem,
    selectedVehicleComponent,
  ]);

  useEffect(() => {
    // When the selected Variant is changed, make the Zone state to default
    setZoneOptionsList([]);
    setSelectedZone(null);
    setSelectedZoneDetails(null);
  }, [selectedVariant]);

  useEffect(() => {
    // When the selected Zone is changed, make the EE Components state to default
    setEEOptionsList([]);
    setSelectedEE(null);
    setSelectedEEDetails(null);
    // When the selected Zone is changed, make the Vehicle Systems state to default
    setVehicleSystemOptionsList([]);
    setSelectedVehicleSystem(null);
    setSelectedVehicleSystemDetails(null);
  }, [selectedVariant, selectedZone]);

  useEffect(() => {
    // When the selected Zone/EE Component is changed, make the Software Modules state to default
    setSWMOptionsList([]);
    setSelectedSWM(null);
    setSelectedSWMDetails(null);
  }, [selectedVariant, selectedZone, selectedEE]);

  useEffect(() => {
    // When the selected Zone/Vehicle System is changed, make the Vehicle Component state to default
    setVehicleComponentOptionsList([]);
    setSelectedVehicleComponent(null);
    setSelectedVehicleComponentDetails(null);
  }, [selectedVariant, selectedZone, selectedVehicleSystem]);

  useEffect(() => {
    if (selectedProjectDetails?.project_id) {
      // Get variant details
      getVariantDetails({
        projectId: selectedProjectDetails?.project_id,
      });
    }
  }, [selectedProjectDetails]);

  useEffect(() => {
    // Get variant options list
    let filteredVariantOptionsList = variantDetails
      ?.map((el) => {
        return {
          value: el?.variant_id,
          label: el?.name,
        };
      })
      ?.sort((a, b) => a.label.localeCompare(b.label));

    console.log(
      "filteredVariantOptionsListfilteredVariantOptionsList",
      filteredVariantOptionsList,
    );

    setVariantOptionsList(filteredVariantOptionsList);

    // Select the first variant
    if (filteredVariantOptionsList?.length) {
      setSelectedVariant(filteredVariantOptionsList?.[0]?.value);
    }
  }, [variantDetails]);

  useEffect(() => {
    // Get variant details
    let filteredVariantDetails = variantDetails?.find(
      (el) => Number.parseInt(el?.variant_id) === Number.parseInt(selectedVariant),
    );
    setSelectedVariantDetails(filteredVariantDetails);
  }, [selectedVariant]);

  useEffect(() => {
    // If Centralized project, Get the EE Components Details, When the project is selected
    if (
      selectedProjectDetails?.project_id &&
      !selectedProjectDetails?.is_zonal &&
      selectedVariantDetails?.variant_id
    ) {
      getZoneEEDetails({
        projectId: selectedProjectDetails?.project_id,
        variantId: selectedVariantDetails?.variant_id,
      });
      getVehicleSystemsDetails({
        projectId: selectedProjectDetails?.project_id,
        variantId: selectedVariantDetails?.variant_id,
      });
    }

    // Zones options list
    let filteredZoneOptionsList = selectedVariantDetails?.zone_details
      ?.map((el) => {
        return {
          // value: el?.sequence,
          value: el?.zone?.position,
          label: el?.zone?.zone_name,
        };
      })
      ?.sort((a, b) => a.label.localeCompare(b.label));
    setZoneOptionsList(filteredZoneOptionsList);
    // Select the first zone, when the selected variant is changed
    if (filteredZoneOptionsList?.length) {
      setSelectedZone(filteredZoneOptionsList?.[0]?.value);
    }
  }, [selectedVariantDetails]);

  useEffect(() => {
    /* Update selected zone details based on the selected zone */
    let filteredSelectedZoneDetails =
      selectedVariantDetails?.zone_details?.find(
        (el) => el?.position == selectedZone,
      );
    setSelectedZoneDetails(filteredSelectedZoneDetails);

    // If Zonal project, Get the EE Components Details, When the zone is selected
    if (
      selectedProjectDetails?.project_id &&
      selectedVariantDetails?.variant_id &&
      selectedZone
    ) {
      getZoneEEDetails({
        projectId: selectedProjectDetails?.project_id,
        variantId: selectedVariantDetails?.variant_id,
        zonePosition: selectedZone,
      });
      getVehicleSystemsDetails({
        projectId: selectedProjectDetails?.project_id,
        variantId: selectedVariantDetails?.variant_id,
        zonePosition: selectedZone,
      });
    }
  }, [selectedZone]);

  useEffect(() => {
    // EE Components Options List
    let filteredEEOptionsList = zoneEEDetails
      ?.map((el) => {
        return {
          value: el?.ee_id,
          label: el?.description,
        };
      })
      ?.sort((a, b) => a.label.localeCompare(b.label));

    console.log(
      "filteredEEOptionsListfilteredEEOptionsListfilteredEEOptionsList",
      filteredEEOptionsList,
    );
    setEEOptionsList(filteredEEOptionsList);

    // Select the first ee component, when the selected zone is changed
    if (filteredEEOptionsList?.length) {
      setSelectedEE(filteredEEOptionsList[0]?.value);
    }
  }, [zoneEEDetails]);

  useEffect(() => {
    // When EE Component is selected, Get the Software Module Details
    if (
      selectedProjectDetails?.project_id &&
      selectedVariantDetails?.variant_id &&
      selectedEE
    ) {
      getEESwmDetails({
        projectId: selectedProjectDetails?.project_id,
        variantId: selectedVariantDetails?.variant_id,
        eeId: selectedEE,
      });
    }

    // Get Selected EE Component details
    let filteredSelectedEEDetails = zoneEEDetails?.find(
      (el) => Number.parseInt(el?.ee_id) === Number.parseInt(selectedEE),
    );
    setSelectedEEDetails(filteredSelectedEEDetails);
  }, [selectedEE]);

  useEffect(() => {
    // Software Module Options List
    let filteredSWMOptionsList = eeSwmDetails
      ?.map((el) => {
        return {
          value: el?.swm_id,
          label: el?.name,
        };
      })
      ?.sort((a, b) => a.label.localeCompare(b.label));
    setSWMOptionsList(filteredSWMOptionsList);

    // Select the first software module, when the selected ee component is changed
    if (filteredSWMOptionsList?.length) {
      setSelectedSWM(filteredSWMOptionsList[0]?.value);
    }
  }, [eeSwmDetails]);

  useEffect(() => {
    // Get Selected Software Module Details
    let filteredEESwmDetails = eeSwmDetails?.find(
      (el) => el?.swm_id == selectedSWM,
    );
    setSelectedSWMDetails(filteredEESwmDetails);
  }, [selectedSWM]);

  useEffect(() => {
    // Vehicle Systems Options List
    let filteredVehicleSystemOptionsList = vehicleSystemDetails
      ?.map((el) => {
        return {
          value: el?.id,
          label: el?.assembly_number,
        };
      })
      ?.sort((a, b) => a.label.localeCompare(b.label));
    setVehicleSystemOptionsList(filteredVehicleSystemOptionsList);

    // Select the first Vehicle System, when the selected zone is changed
    if (filteredVehicleSystemOptionsList?.length) {
      setSelectedVehicleSystem(filteredVehicleSystemOptionsList[0]?.value);
    }
  }, [vehicleSystemDetails]);

  useEffect(() => {
    // When Vehicle System is selected, Get the Vehicle Component Details
    if (
      selectedProjectDetails?.project_id &&
      selectedVariantDetails?.variant_id &&
      selectedVehicleSystem
    ) {
      getVehicleComponentsDetails({
        projectId: selectedProjectDetails?.project_id,
        variantId: selectedVariantDetails?.variant_id,
        vsId: selectedVehicleSystem,
      });
    }

    // Get Selected Vehicle System details
    let filteredSelectedVehicleSystemDetails = vehicleSystemDetails?.find(
      (el) => Number.parseInt(el?.id) === Number.parseInt(selectedVehicleSystem),
    );
    setSelectedVehicleSystemDetails(filteredSelectedVehicleSystemDetails);
  }, [selectedVehicleSystem]);

  useEffect(() => {
    // Vehicle Component Options List
    let filteredVehicleComponentOptionsList = vehicleComponentDetails
      ?.map((el) => {
        return {
          value: el?.id,
          label: el?.component_number,
        };
      })
      ?.sort((a, b) => a.label.localeCompare(b.label));
    setVehicleComponentOptionsList(filteredVehicleComponentOptionsList);

    // Select the first Vehicle Component, when the selected vehicle system is changed
    if (filteredVehicleComponentOptionsList?.length) {
      setSelectedVehicleComponent(
        filteredVehicleComponentOptionsList[0]?.value,
      );
    }
  }, [vehicleComponentDetails]);

  useEffect(() => {
    // Get Selected Software Module Details
    let filteredVehicleComponentDetails = vehicleComponentDetails?.find(
      (el) => Number.parseInt(el?.id) === Number.parseInt(selectedVehicleComponent),
    );
    setSelectedVehicleComponentDetails(filteredVehicleComponentDetails);
  }, [selectedVehicleComponent]);

  // sonar helper function
  const getAccessType = () => {
    if (selectedAtBtn === accessTypes?.COOWNER) return accessTypes?.COOWNER;
    if (selectedAtBtn === accessTypes?.EDITOR) return accessTypes?.EDITOR;
    return accessTypes?.VIEWER;
  };

  const getModuleType = () => {
    if (selectedPaBtn === moduleTypes?.PROJECT) return moduleTypes?.PROJECT;
    if (selectedPaBtn === moduleTypes?.VARIANT) return moduleTypes?.VARIANT;
    if (selectedPaBtn === moduleTypes?.ZONE) return moduleTypes?.ZONE;
    if (selectedPaBtn === moduleTypes?.EE) return moduleTypes?.EE;
    if (selectedPaBtn === moduleTypes?.SWM) return moduleTypes?.SWM;
    if (selectedPaBtn === moduleTypes?.VEHICLE_SYSTEM)
      return moduleTypes?.VEHICLE_SYSTEM;
    return moduleTypes?.VEHICLE_COMPONENT;
  };

  const isZoneType =
    selectedPaBtn === moduleTypes?.ZONE ||
    selectedPaBtn === moduleTypes?.EE ||
    selectedPaBtn === moduleTypes?.SWM;

  const isEEType =
    selectedPaBtn === moduleTypes?.EE || selectedPaBtn === moduleTypes?.SWM;

  const isVehicleSystemType =
    selectedPaBtn === moduleTypes?.VEHICLE_SYSTEM ||
    selectedPaBtn === moduleTypes?.VEHICLE_COMPONENT;

  return (
    // New Request
    // <Box sx={styles.nrContainer}>
    //   {/* Module Access Types */}
    //   <Box>
    //     <ModuleAccessTypes
    //       selectedProjectDetails={selectedProjectDetails}
    //       selectedPaBtn={selectedPaBtn}
    //       setSelectedPaBtn={setSelectedPaBtn}
    //       moduleTypes={moduleTypes}
    //       hideProject={true}
    //     />
    //   </Box>

    //   {/* Request access */}
    //   <Box sx={styles.nrMainContainer}>
    //     <SelectModules
    //       selectedProjectDetails={selectedProjectDetails}
    //       selectedPaBtn={selectedPaBtn}
    //       moduleTypes={moduleTypes}
    //       variantOptionsList={variantOptionsList}
    //       selectedVariant={selectedVariant}
    //       setSelectedVariant={setSelectedVariant}
    //       zoneOptionsList={zoneOptionsList}
    //       selectedZone={selectedZone}
    //       setSelectedZone={setSelectedZone}
    //       eeOptionsList={eeOptionsList}
    //       selectedEE={selectedEE}
    //       setSelectedEE={setSelectedEE}
    //       swmOptionsList={swmOptionsList}
    //       selectedSWM={selectedSWM}
    //       setSelectedSWM={setSelectedSWM}
    //       vehicleSystemOptionsList={vehicleSystemOptionsList}
    //       selectedVehicleSystem={selectedVehicleSystem}
    //       setSelectedVehicleSystem={setSelectedVehicleSystem}
    //       vehicleComponentOptionsList={vehicleComponentOptionsList}
    //       selectedVehicleComponent={selectedVehicleComponent}
    //       setSelectedVehicleComponent={setSelectedVehicleComponent}
    //     />
    //     {/* Project Details */}
    //     {/* <ProjectDetails
    //       selectedProjectDetails={selectedProjectDetails}
    //       projectStatus={projectStatus}
    //     /> */}

    //     {/* Select Access type with reason and send request */}
    //     <Box sx={styles.nrATContainer}>
    //       {/* Access Types */}
    //       <Box sx={styles.nrATPContainer}>
    //         <Typography
    //           variant="subtitle1"
    //           sx={{ ...styles.nrDetailsTxt, marginRight: 1 }}
    //         >
    //           <span style={styles.txtBold}>Access Type: </span>
    //         </Typography>
    //         <ButtonGroup size="small">
    //           {[
    //             { value: accessTypes?.COOWNER, label: "Co-Owner" },
    //             { value: accessTypes?.EDITOR, label: "Editor" },
    //             { value: accessTypes?.VIEWER, label: "Viewer" },
    //           ].map((el) => (
    //             <Button
    //               sx={{
    //                 color: "black",
    //                 borderRadius: 0,
    //                 borderColor: "#333",
    //                 backgroundColor:
    //                   // selectedAtBtn === el?.value ? "#26890D" : "transparent",
    //                   selectedAtBtn === el?.value
    //                     ? customAppColors?.green
    //                     : "transparent",
    //                 "&:hover": {
    //                   borderColor: "#333",
    //                   backgroundColor:
    //                     // selectedAtBtn == el?.value ? "#37b518" : "#f0f0f0",
    //                     customAppColors?.lightGreen,
    //                 },
    //               }}
    //               onClick={() => setSelectedAtBtn(el?.value)}
    //             >
    //               {el?.label}
    //             </Button>
    //           ))}
    //         </ButtonGroup>
    //       </Box>


    //       <Box
    //       // sx={styles.nrATTbContainer}
    //       >
    // <Box sx={styles.nrATTContainer}>
    //   <CustomTextFieldN
    //     size={"small"}
    //     placeholder={"Reason for access"}
    //     type={"text"}
    //     isMultiline={true}
    //     minRows={3}
    //     maxRows={5}
    //     value={reasonForAccess}
    //     setValue={setReasonForAccess}
    //     variant={"outlined"}
    //     txtFldStyle={styles.customTextFieldN}
    //   />
    // </Box>
    // <Box sx={styles.nrATbContainer}>
    //   <CustomButton
    //     size={"small"}
    //     btnName={"Send Request"}
    //     disabled={
    //       // There should be a reason for access
    //       !reasonForAccess ||
    //       reasonForAccess.length < 5 ||
    //       // Project Access Validation
    //       (selectedPaBtn === moduleTypes?.PROJECT &&
    //         !selectedProjectDetails?.project_id) ||
    //       // Variant Validation
    //       (selectedPaBtn === moduleTypes?.VARIANT &&
    //         (!selectedProjectDetails?.project_id ||
    //           !selectedVariant?.value)) ||
    //       // Zone Access Validation
    //       (selectedPaBtn === moduleTypes?.ZONE &&
    //         (!selectedProjectDetails?.project_id ||
    //           !selectedVariant?.value ||
    //           !selectedZone?.value)) ||
    //       // EE Component Access Validation
    //       (selectedPaBtn === moduleTypes?.EE &&
    //         (!selectedProjectDetails?.project_id ||
    //           !selectedVariant?.value ||
    //           !selectedEEDetails?.ee_id)) ||
    //       // Software Module Access Validation
    //       (selectedPaBtn === moduleTypes?.SWM &&
    //         (!selectedProjectDetails?.project_id ||
    //           !selectedVariant?.value ||
    //           !selectedEEDetails?.ee_id ||
    //           !selectedSWMDetails?.swm_id)) ||
    //       // Vehicle System Validation
    //       (selectedPaBtn === moduleTypes?.VEHICLE_SYSTEM &&
    //         (!selectedProjectDetails?.project_id ||
    //           !selectedVariant?.value ||
    //           !selectedVehicleSystem?.value)) ||
    //       // Vehicle Component Validation
    //       (selectedPaBtn === moduleTypes?.VEHICLE_COMPONENT &&
    //         (!selectedProjectDetails?.project_id ||
    //           !selectedVariant?.value ||
    //           !selectedVehicleComponent?.value))
    //     }
    //     handleOnClick={() =>
    //       requestAccess({
    //         accessType:
    //           selectedAtBtn === accessTypes?.COOWNER
    //             ? accessTypes?.COOWNER
    //             : selectedAtBtn === accessTypes?.EDITOR
    //             ? accessTypes?.EDITOR
    //             : accessTypes?.VIEWER,
    //         moduleType:
    //           selectedPaBtn === moduleTypes?.PROJECT
    //             ? moduleTypes?.PROJECT
    //             : selectedPaBtn === moduleTypes?.VARIANT
    //             ? moduleTypes?.VARIANT
    //             : selectedPaBtn === moduleTypes?.ZONE
    //             ? moduleTypes?.ZONE
    //             : selectedPaBtn === moduleTypes?.EE
    //             ? moduleTypes?.EE
    //             : selectedPaBtn === moduleTypes?.SWM
    //             ? moduleTypes?.SWM
    //             : selectedPaBtn === moduleTypes?.VEHICLE_SYSTEM
    //             ? moduleTypes?.VEHICLE_SYSTEM
    //             : moduleTypes?.VEHICLE_COMPONENT,
    //         projectId: selectedProjectDetails?.project_id,
    //         variantId: selectedVariantDetails?.variant_id,
    //         // zonePosition: (selectedPaBtn === moduleTypes?.ZONE || selectedPaBtn === moduleTypes?.EE || selectedPaBtn === moduleTypes?.SWM) && selectedZone?.value,
    //         zonePosition:
    //           (selectedPaBtn === moduleTypes?.ZONE ||
    //             selectedPaBtn === moduleTypes?.EE ||
    //             selectedPaBtn === moduleTypes?.SWM) &&
    //           selectedZone?.value,
    //         eeId:
    //           (selectedPaBtn === moduleTypes?.EE ||
    //             selectedPaBtn === moduleTypes?.SWM) &&
    //           selectedEE?.value,
    //         swmId:
    //           selectedPaBtn === moduleTypes?.SWM && selectedSWM?.value,
    //         vsId:
    //           (selectedPaBtn === moduleTypes?.VEHICLE_SYSTEM ||
    //             selectedPaBtn === moduleTypes?.VEHICLE_COMPONENT) &&
    //           selectedVehicleSystem?.value,
    //         vcId:
    //           selectedPaBtn === moduleTypes?.VEHICLE_COMPONENT &&
    //           selectedVehicleComponent?.value,
    //         requestReason: reasonForAccess,
    //       })
    //     }
    //     // btnStyle={styles.customButton}
    //   />
    // </Box>
    //   </Box>
    // </Box>
    //   </Box>

    //   <Box>
    //     {/* Project Details */}
    //     <ProjectDetails
    //       selectedProjectDetails={selectedProjectDetails}
    //       projectStatus={projectStatus}
    //     />

    //     {/* Vehicle Component Details */}
    //     {selectedPaBtn === moduleTypes?.VEHICLE_COMPONENT &&
    //       selectedVehicleComponent && (
    //         <VehicleComponentDetails
    //           selectedVehicleComponentDetails={selectedVehicleComponentDetails}
    //         />
    //       )}
    //   </Box>
    // </Box>
    <Box sx={styles.nrContainer}>
      {/* 1️⃣ LEFT – Module Access Types (LESS WIDTH) */}
      <Box>
        <ModuleAccessTypes
          selectedProjectDetails={selectedProjectDetails}
          selectedPaBtn={selectedPaBtn}
          setSelectedPaBtn={setSelectedPaBtn}
          moduleTypes={moduleTypes}
          hideProject={true}
        />
      </Box>

      {/* CENTER – Main Content (MAX WIDTH) */}
      <Box sx={styles.centerPanel}>
        <SelectModules
          selectedProjectDetails={selectedProjectDetails}
          selectedPaBtn={selectedPaBtn}
          moduleTypes={moduleTypes}
          variantOptionsList={variantOptionsList}
          selectedVariant={selectedVariant}
          setSelectedVariant={setSelectedVariant}
          zoneOptionsList={zoneOptionsList}
          selectedZone={selectedZone}
          setSelectedZone={setSelectedZone}
          eeOptionsList={eeOptionsList}
          selectedEE={selectedEE}
          setSelectedEE={setSelectedEE}
          swmOptionsList={swmOptionsList}
          selectedSWM={selectedSWM}
          setSelectedSWM={setSelectedSWM}
          vehicleSystemOptionsList={vehicleSystemOptionsList}
          selectedVehicleSystem={selectedVehicleSystem}
          setSelectedVehicleSystem={setSelectedVehicleSystem}
          vehicleComponentOptionsList={vehicleComponentOptionsList}
          selectedVehicleComponent={selectedVehicleComponent}
          setSelectedVehicleComponent={setSelectedVehicleComponent}
        />

        {/* <Box sx={styles.nrATPContainer}>
          <Typography
            variant="subtitle1"
            sx={{ ...styles.nrDetailsTxt, marginRight: 1 }}
          >
            <span style={styles.txtBold}>Access Type: </span>
          </Typography>
          <ButtonGroup size="small">
            {[
              { value: accessTypes?.COOWNER, label: "Co-Owner" },
              { value: accessTypes?.EDITOR, label: "Editor" },
              { value: accessTypes?.VIEWER, label: "Viewer" },
            ].map((el) => (
              <CustomButtonV2
                sx={{
                  color: "black",
                  borderRadius: 0,
                  borderColor: "#333",
                  backgroundColor:
                    //                   // selectedAtBtn === el?.value ? "#26890D" : "transparent",
                    selectedAtBtn === el?.value
                      ? customAppColors?.green
                      : "transparent",
                  "&:hover": {
                    borderColor: "#333",
                    backgroundColor:
                      //                     // selectedAtBtn == el?.value ? "#37b518" : "#f0f0f0",
                      customAppColors?.lightGreen,
                  },
                }}
                onClick={() => setSelectedAtBtn(el?.value)}
              >
                {el?.label}
              </CustomButtonV2>
            ))}
          </ButtonGroup>
        </Box> */}
        <Box sx={{ mt: 2 }}>
          <CustomRadioButtonV3
            size="small"
            label="Access Type:"
            data={[
              { value: accessTypes?.COOWNER, label: "Co-Owner" },
              { value: accessTypes?.EDITOR, label: "Editor" },
              { value: accessTypes?.VIEWER, label: "Viewer" },
            ]}
            value={selectedAtBtn}
            onChange={(e) => setSelectedAtBtn(e.target.value)}
            txtFldStyle={styles.customTextFieldN}
            direction="row"
            gap={1}
          />
        </Box>

        {console.log("selectedAtBtnselectedAtBtn", selectedAtBtn)}

        {/* Access Type + Reason */}
        <Box sx={styles.nrATTContainer}>
          <CustomFormTextFieldV2
            size={"small"}
            fldType={"text"}
            placeholder={"Reason for access"}
            type={"text"}
            isMultiline={true}
            minRows={3}
            maxRows={5}
            value={reasonForAccess}
            setValue={setReasonForAccess}
            variant={"outlined"}
            txtFldStyle={styles.customTextFieldN}
            resetTrigger={accessTypeKey}
          />
        </Box>
        <Box sx={styles.nrATbContainer}>
          <CustomButtonV2
            size={"small"}
            btnName={"Send Request"}
            disabled={
              // There should be a reason for access
              !reasonForAccess ||
              reasonForAccess.length < 5 ||
              // Project Access Validation
              (selectedPaBtn === moduleTypes?.PROJECT &&
                !selectedProjectDetails?.project_id) ||
              // Variant Validation
              (selectedPaBtn === moduleTypes?.VARIANT &&
                (!selectedProjectDetails?.project_id || !selectedVariant)) ||
              // Zone Access Validation
              (selectedPaBtn === moduleTypes?.ZONE &&
                (!selectedProjectDetails?.project_id ||
                  !selectedVariant?.value ||
                  !selectedZone)) ||
              // EE Component Access Validation
              (selectedPaBtn === moduleTypes?.EE &&
                (!selectedProjectDetails?.project_id ||
                  !selectedVariant ||
                  !selectedEEDetails?.ee_id)) ||
              // Software Module Access Validation
              (selectedPaBtn === moduleTypes?.SWM &&
                (!selectedProjectDetails?.project_id ||
                  !selectedVariant ||
                  !selectedEEDetails?.ee_id ||
                  !selectedSWMDetails?.swm_id)) ||
              // Vehicle System Validation
              (selectedPaBtn === moduleTypes?.VEHICLE_SYSTEM &&
                (!selectedProjectDetails?.project_id ||
                  !selectedVariant ||
                  !selectedVehicleSystem)) ||
              // Vehicle Component Validation
              (selectedPaBtn === moduleTypes?.VEHICLE_COMPONENT &&
                (!selectedProjectDetails?.project_id ||
                  !selectedVariant ||
                  !selectedVehicleComponent))
            }
            
            handleOnClick={() =>
              requestAccess({
                accessType: getAccessType(),
                moduleType: getModuleType(),
                projectId: selectedProjectDetails?.project_id,
                variantId: selectedVariantDetails?.variant_id,

                zonePosition: isZoneType && selectedZone?.value,
                eeId: isEEType && selectedEE,
                swmId: selectedPaBtn === moduleTypes?.SWM && selectedSWM,

                vsId: isVehicleSystemType && selectedVehicleSystem,
                vcId:
                  selectedPaBtn === moduleTypes?.VEHICLE_COMPONENT &&
                  selectedVehicleComponent,

                requestReason: reasonForAccess,
              })
            }
            
          />
        </Box>
      </Box>

      {/* 3️⃣ RIGHT – Details (MEDIUM WIDTH) */}
      <Box sx={styles.rightPanel}>
        <ProjectDetails
          selectedProjectDetails={selectedProjectDetails}
          projectStatus={projectStatus}
        />

        <VariantDetailsBox selectedVariantDetails={selectedVariantDetails} />

        {selectedPaBtn === moduleTypes?.EE && selectedEE && (
          <EEDetails selectedEEDetails={selectedEEDetails} />
        )}

        {selectedPaBtn === moduleTypes?.SWM && selectedSWM && (
          <SWMDetails selectedSWMDetails={selectedSWMDetails} />
        )}

        {selectedPaBtn === moduleTypes?.VEHICLE_SYSTEM &&
          selectedVehicleSystem && (
            <VehicleSystemDetails
              selectedVehicleSystemDetails={selectedVehicleSystemDetails}
            />
          )}

        {selectedPaBtn === moduleTypes?.VEHICLE_COMPONENT &&
          selectedVehicleComponent && (
            <VehicleComponentDetails
              selectedVehicleComponentDetails={selectedVehicleComponentDetails}
            />
          )}
      </Box>
    </Box>
  );
}

export default NewRequestTab;


const styles = {
  nrContainer: {
    display: "flex",
    width: "100%",
    height: "calc(100vh - 120px)", // adjust if header exists
    overflow: "hidden",
  },
  nrATTContainer: {
    flexGrow: 1,
    mt: 1,
  },

  /* 1️⃣ LEFT – SMALL */
  leftPanel: {
    width: 200, // 👈 LESS WIDTH
    minWidth: 200,

    overflowY: "auto",
  },

  /* 2️⃣ CENTER – MAX */
  centerPanel: {
    flex: 1, // 👈 TAKES MAX SPACE
    padding: "0 24px",
    overflowY: "auto",

    ml: 1,
  },

  /* 3️⃣ RIGHT – MEDIUM */
  rightPanel: {
    width: 250,
    minWidth: 250,

    padding: "0 16px",

    ml: 1,

    /* 👇 SCROLL MAGIC */
    height: "100%",
    overflowY: "auto",
    overflowX: "hidden",
  },

  nrATContainer: {
    marginTop: 24,
    paddingBottom: 16,
  },
  nrATbContainer: {
    mt: 2,
    display: "flex",
    justifyContent: "flex-end",
  },
  customTextFieldN: {
    "& .MuiOutlinedInput-root": {
      "& fieldset": {
        borderColor: "#000000", // default border → black
      },
      "&:hover fieldset": {
        borderColor: "#000000", // hover border → black
      },
      "&.Mui-focused fieldset": {
        borderColor: "#000000", // focused border → black
      },
    },
  },
};
